

<template>
    <div class="block_inp internal_doc p-3">
        <div class="step row ">
            <div class="label_step col-4"><b> Служба* </b></div>
            <div class="col-7"><b> Напрямок</b></div>
            <div class="col-1"></div>
        </div>
        
        <div class="but_add_dell  first" v-on:click="add_service_row">
            <div class="add service fs-xxl color-primary-800 cursor-pointer">
                <i title="" class="fa add_service fa-plus-square" data-type="approve_list"></i>
            </div>
        </div>
        
        <div class="directions_items" v-if="this.doc.service_directions.length > 0">
            <div class="step row mt-3 pb-2" v-for="direction,idx in this.doc.service_directions">
                <div class="label_step col-4">
                    <v-select
                        :reduce="active_doc => active_doc.id"
                        v-model="direction.department_id"
                        class="imc_reasons"
                        label="title"
                        @input="load_department_direction"
                        :options="departments"
                        :filterable="true"
                    >
                    </v-select>
                </div>
                
                <div class="col-7">
                    <v-select
                        v-if="direction.department_directions.length > 0"
                        :reduce="active_doc => active_doc.id"
                        v-model="direction.direction_id"
                        class="imc_reasons"
                        label="title"
                        :options="direction.department_directions"
                        :filterable="true"
                    >
                    </v-select>
                    <div class="text-center" v-else> - </div>
                    
                </div>
                
                <div class="col-1 text-center">
                    <i class="fa fa-trash cursor-pointer color-danger-500 mt-2  active" aria-hidden="true" v-on:click="remove(idx)"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
export default {
    name: "internal_direction",
    components : {
        vSelect
    },
    
    props : {
        doc : {
            type : Object
        }
    },
    
    data() {
        return {
            departments : [],
        }
    },
    
    created() {
        this.load_departments();
    },
    
    methods : {
        
        remove(idx) {
            this.doc.service_directions.splice(idx,1);
        },
        
        add_service_row() {
            this.doc.service_directions.push({
                "id" : 0,
                "department_id" : null,
                'direction_id' : null,
                "department_directions" : [],
            });
        },
        
        async load_department_direction(dep_id) {
            
            this.push_department_directions(dep_id,[]);
            if(parseInt(dep_id) > 0) {
                await api.get('/internal/departments/' + dep_id + '/directions').then(({data}) => {
                    this.is_load = true;
                    if (data.status === "operation_success") {
                        this.push_department_directions(dep_id, data.data);
                    }
                }).catch(err => {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                    this.is_load = false;
                });
            }
        },
        
        push_department_directions(dep_id,to_push) {
            this.doc.service_directions.map(item => {
                let cur_id = parseInt(item.department_id);
                if(cur_id === parseInt(dep_id)) {
                    item.department_directions = [];
                    to_push.map(val => {
                        item.department_directions.push(val);
                    })
                }
            });
        },
        
        
        async load_departments() {
            this.departments = [];
            await api.get('/departments').then(({data}) => {
                this.is_load = true;
                if (data.status === "operation_success") {
                    this.departments = data.data;
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                this.is_load = false;
            });
        },
    }
}
</script>


<style scoped>

</style>